import Icon from '../Icon.vue'

Icon.register({
  'link_65': {
    width: 17,
    height: 22,
    paths: [
      {
        d: 'M8.74 17.878l-.631-1.355c-.234-.502-.063-1.075.383-1.282.445-.208.994.03 1.228.53l.607 1.302c.384.825 1.42 1.158 2.308.744.889-.414 1.299-1.422.914-2.247l-2.41-5.167c-.383-.824-1.419-1.157-2.307-.743-.446.208-.995-.03-1.229-.53-.233-.502-.062-1.075.383-1.282 1.778-.83 3.915-.02 4.765 1.804l2.434 5.22c.01.022.02.044.028.066.764 1.797.006 3.88-1.732 4.692-1.739.81-3.823.052-4.708-1.69a.94.94 0 01-.033-.062z',
        transform: 'translate(2.19272 1.55334)'
      },
      {
        d: 'M4.952 11.856l-2.435-5.22a.927.927 0 01-.027-.066c-.765-1.797-.006-3.88 1.732-4.692 1.739-.81 3.822-.052 4.708 1.69.011.02.022.04.032.062l.632 1.355c.234.501.063 1.074-.383 1.282-.445.208-.994-.03-1.228-.53l-.607-1.302c-.384-.824-1.42-1.158-2.309-.744-.888.414-1.298 1.423-.913 2.247l2.409 5.167c.384.823 1.42 1.157 2.308.743.445-.208.995.03 1.228.53.234.502.063 1.075-.383 1.282-1.777.83-3.914.02-4.764-1.804z',
        transform: 'translate(2.19272 1.55334)'
      }
    ]
  }
})
